import React, { useState, useEffect } from "react";
import {
  Typography,
  Divider,
  Row,
  Col,
  Upload,
  Form,
  Button,
  message,
  Image,
} from "antd";
import { InboxOutlined } from "@ant-design/icons";
import DiscountService from "../../../services/DiscountService";
import CustomizationService from "../../../services/CustomizationService";
import CustomInput from "../../../components/CustomInput";
import CustomSelect from "../../../components/CustomSelect";
import { useHistory } from "react-router-dom";

import {
  convertFormDataToObject,
  dummyRequest,
  transformImageFileToUrlObject,
} from "../../../utils";
import MenuTemplate from "./MenuTemplate";
import TestimonialService from "../../../services/TestimonialService";
import MenuService from "../../../services/MenuService";

const { Dragger } = Upload;
const { Title } = Typography;

export default function Menu({ isPreview }) {
  const [customizationData, setCustomizationData] = useState({});
  const [discountData, setDiscountData] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [formFieldsdata, setFormFieldsData] = useState();
  const [menuItems, setMenuItems] = useState([]);
  const [Featuredmenu, setFeaturedMenu]= useState()
  


  const [form] = Form.useForm();
  const history = useHistory();

  let restaurantID = localStorage.getItem("restaurantId");

  useEffect(() => {
    fetchDiscountCodes();
    fetchCustomizationData();
    fetchMenus()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchMenus = async () => {
    const data = await MenuService.getMenus(restaurantID);
    setMenuItems(data?.menus || []);
  };
  const fetchDiscountCodes = async () => {
    const data = await DiscountService.getDiscountDetails();
    setDiscountData(data.discount_codes || []);
  };

  const removeNullValues = (obj) => {
    // Create a new object without null values
    return Object.fromEntries(
      Object.entries(obj).filter(([key, value]) => value !== null)
    );
  };
  const saveCustomizationData = async () => {
    setIsSaving(true);
    try {

      const cleanedPayload = removeNullValues(formFieldsdata);
      delete cleanedPayload?.menu_items;
      delete cleanedPayload?.menu_items;
      delete cleanedPayload?.banner_heading;
      delete cleanedPayload?.catering_event_types;
      delete cleanedPayload?.certifications;
      delete cleanedPayload?.created_at;
      delete cleanedPayload?.id;
      delete cleanedPayload?.landing_page_button_title;
      delete cleanedPayload?.our_story_description;
      delete cleanedPayload?.restaurant_id;
      delete cleanedPayload?.restaurant_special_tagline;
      delete cleanedPayload?.testimonials;
      delete cleanedPayload?.theme;
      delete cleanedPayload?.updated_at;
      delete cleanedPayload?.updated_by;
      const updatedData = {
        ...cleanedPayload,
        our_story_featured_menu: Number(Featuredmenu)
    };
    const saveBuilder =   await CustomizationService.saveCustomization(
        restaurantID,
        updatedData
      );
      if (saveBuilder)
      message.success("Update Successful");

      setIsSaving(false)
    } catch (error) {
      setIsSaving(false);
      message.error("Update Failed");
    }
  };

  const fetchCustomizationData = async () => {
    const data = await CustomizationService.getCustomizations(restaurantID);
    setFeaturedMenu(data?.our_story_featured_menu)
    form.setFieldsValue(data);
    setFormFieldsData(data)
    setCustomizationData(data);
  };

  const handleImageChange =async(info,type)=>{
    const formData = new FormData();
        formData.append('file', info.file.originFileObj);
        const  data  = await TestimonialService.uploadPhoto(formData); 
        if(data){
          form.setFieldsValue({[type]: data.url})
          setFormFieldsData(form.getFieldsValue())
        }  
  }

  const gandleFormValueChanges = (changedValue, allValues)=>{
    setFormFieldsData(form.getFieldsValue())
  }

  return (
    <Row
      style={{
        background: "#FFFFFF",
        padding: 16,
        borderRadius: 5,
      }}
    >
       <Col xs={24} lg={12}>
      <Form
        form={form}
        name="menu"
        onFieldsChange={(_, allFields) => {
          setCustomizationData(convertFormDataToObject(allFields));
        }}
        onValuesChange={gandleFormValueChanges}
        scrollToFirstError
      
      >
        <div className="theme-container">
          <Row>
            <Col span={24}>
              <Title level={5} className="theme-red mb-1">
                Discount Banner
              </Title>
              <div className="mb-1">Upload Image</div>
              <Form.Item name="menu_discount_heading">
                <CustomInput label="Heading" placeholder="Enter heading here" />
              </Form.Item>
              <Form.Item name="menu_discount_id">
                <CustomSelect
                  label="Discount Code"
                  placeholder="Select Discount code here"
                  options={discountData}
                  fieldNames={{ value: "id", label: "code" }}
                />
              </Form.Item>
              <div
                className="theme-red img-btn mb-1"
                onClick={() => history.push("/business/discounts")}
              >
                Create Discount +
              </div>
              <div className="mb-1">Upload Discount Banner Image</div>
              <Form.Item name="menu_discount_image_url">
                <Dragger
                  multiple={false}
                  customRequest={dummyRequest}
                  maxCount={1}
                  onChange={(info)=>handleImageChange(info,'menu_discount_image_url')}
                >
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    Click or drag file to this area to upload
                  </p>
                </Dragger>
              </Form.Item>
              {/* {typeof customizationData.menu_discount_image_url ===
                "string" && (
                <Image
                  width={200}
                  src={customizationData.menu_discount_image_url}
                />
              )} */}

              <Divider />
              <div className="d-flex justify-space-between items-center">
                <Title level={5} className="theme-red mb-1">
                  Menu Items
                </Title>
              </div>
              <p className="ant-upload-text mb-1" style={{ color: "#3A3A3A" }}>
                Menu Items will be displayed based on the timings specified
                while creating the menus.
              </p>
              <Button
                type="outline"
                className="btn-custom  outline"
                onClick={() => {history.push('/menu/list')}}
              >
                Go to Menu
              </Button>
            </Col>
          </Row>
          <div className="flex justify-center mt-2">
            <Button
              type="primary"
              className="custom-btn"
              disabled={isSaving}
              onClick={saveCustomizationData}
            >
              Save
            </Button>
          </div>
        </div>
      </Form>
      </Col>
      <Col xs={24} lg={12}>
      
        <MenuTemplate data={customizationData} formFieldsdata = {formFieldsdata}
        discountData={discountData}
        menuItems={menuItems}/>
      </Col>
    </Row>
  );
}
